// extracted by mini-css-extract-plugin
export default {"label":"ArchitectureLabelGroup_label__TiGBQ","container":"ArchitectureLabelGroup_container__O3lAB"};